import { takeLatest, call, put } from "redux-saga/effects";
import {
  fetchDataBegin,
  fetchDataError,
  getRoleOptionsDataSuccess,
} from "./slice";
import { apiGet } from "../../api/callApi";
import { getRoleOptions } from "./actions";

function* getRoleOptionsData(action) {
  yield put(fetchDataBegin());
  try {
    const response = yield call(apiGet, `/v1/roles?active=true`, false);
    yield put(getRoleOptionsDataSuccess({ newData: response.data }));
  } catch (error) {
    yield put(fetchDataError({ message: error.response.data.message }));
    console.error("Get company failed", error);
  }
}

export function* watchRoleOptionsData() {
  yield takeLatest(getRoleOptions.type, getRoleOptionsData);
}
